import { Grid, makeStyles } from '@material-ui/core'
import React, { useEffect, useMemo } from 'react'
import { Virtuoso } from 'react-virtuoso'
import BaseCreatePage from '../../../../components/hooks/BaseCreatePage'
import Filter from './Filter'
import Tabs from '../../../../components/hooks/BaseTabs/Tabs'
import Tab from '../../../../components/hooks/BaseTabs/Tab'
import colors from '../../../../assets/colors'
import CardLead from './CardLead'
import { useDispatch, useSelector } from 'react-redux'
import { fetchLeads } from '../PanelActions'
import { useConfirm } from 'material-ui-confirm'
import {
  renderRoute,
  renderRouteRole,
  useQueryParams,
} from '../../../../util/utils'
import LeadForm from './lead'
import { Route } from 'react-router-dom/cjs/react-router-dom'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'

function chunkArray(arr, size) {
  const result = []
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size))
  }
  return result
}

const useStyles = makeStyles({
  scroller: {
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      width: '3px',
      height: '8px',
      backgroundColor: colors.graylight,
    },
    '&::-webkit-scrollbar-thumb': {
      background: colors.secondary,
    },
  },
})

const CrmPanel = () => {
  const leads = useSelector(state => state.crmPanel.leads)
  const role = useSelector(state => state.auth.role)

  const dispatch = useDispatch()
  const classes = useStyles()

  const ScrollerComponent = useMemo(
    () =>
      React.forwardRef((props, ref) => (
        <div {...props} ref={ref} className={classes.scroller} />
      )),
    [classes.scroller]
  )

  const rows = useMemo(() => chunkArray(leads || [], 3), [leads])

  const location = useLocation()
  const filters = useQueryParams(location.search)
  const history = useHistory()

  const currentTab = useMemo(() => {
    if (!filters.tab) return 0
    return Number(filters.tab)
  })

  const handleChangeTab = tab => {
    const params = new URLSearchParams(filters)
    params.set('tab', tab)
    history.push(`${location.pathname}?${params.toString()}`)
  }

  const handleFetchData = () => {
    const stateByTab = {
      0: 10,
      1: 20,
    }

    const finalFilters = {
      ...filters,
      state: stateByTab[currentTab],
    }

    dispatch(fetchLeads(finalFilters))
  }

  useEffect(() => {
    handleFetchData()
  }, [location])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <BaseCreatePage
          page={'CRM'}
          path={'Painel'}
          hiddenReturn
          pageLink={'#'}
        />
      </Grid>

      <Grid item xs={12}>
        <Filter />
      </Grid>

      <Grid item xs={12}>
        <Tabs>
          <Tab
            tabIndex={0}
            value={currentTab}
            setValue={handleChangeTab}
            label="Entrada"
            removeNavigation={false}
          />
          <Tab
            tabIndex={1}
            value={currentTab}
            setValue={handleChangeTab}
            label="Cadenciamento"
            removeNavigation={false}
            iconColor={colors.sucess}
          />
        </Tabs>
      </Grid>

      <Grid item xs={12}>
        <Virtuoso
          style={{ height: 'calc(100vh - 290px)' }}
          data={rows}
          overscan={300}
          components={{ Scroller: ScrollerComponent }}
          itemContent={(index, row) => (
            <Grid
              container
              spacing={4}
              style={{
                padding: '4px 8px 8px 0',
                marginTop: index === 0 ? '30px' : '0',
              }}
            >
              {row.map((lead, i) => (
                <Grid item sm={6} md={4} xs={12} key={`crm-lead-${index}-${i}`}>
                  <CardLead
                    state={currentTab === 0 ? 10 : 20}
                    triggerType={lead?.trigger_type}
                    clientName={lead?.client_name}
                    schedulingDate={lead?.scheduling_date}
                    os={lead?.os}
                    reason={lead?.reason}
                    leadId={lead?.id}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        />
      </Grid>

      {renderRouteRole(
        ['gerente_lavanderia', 'atendente_lavanderia', 'operador_lavanderia'],
        role
      ) && <Route path="/crm/panel/lead/:id" component={LeadForm} />}
    </Grid>
  )
}

export default CrmPanel
